import { render, staticRenderFns } from "./ViewRolesByEntity.vue?vue&type=template&id=47e9bbf2"
import script from "./ViewRolesByEntity.vue?vue&type=script&lang=js"
export * from "./ViewRolesByEntity.vue?vue&type=script&lang=js"
import style0 from "./ViewRolesByEntity.vue?vue&type=style&index=0&id=47e9bbf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports